import React from "react";
import LegalLayout, { Section } from "./LegalLayout";

export default function DatenschutzPage() {
  return (
    <LegalLayout title="Datenschutzerklärung" lastUpdated="16.05.2026" testId="datenschutz-page">
      <Section>
        <p>
          Der Schutz Ihrer personenbezogenen Daten ist uns ein zentrales
          Anliegen. Wir verarbeiten Ihre Daten ausschließlich auf Grundlage der
          gesetzlichen Bestimmungen (DSGVO, TKG 2003 idF, DSG). In dieser
          Datenschutzerklärung informieren wir Sie über die wichtigsten Aspekte
          der Datenverarbeitung im Rahmen von StudioOps Food.
        </p>
      </Section>

      <Section title="1. Verantwortlicher">
        <p>
          <strong>StudioOps</strong>
          <br />
          Silverio Cosenza
          <br />
          Amalienstraße 57/16
          <br />
          1130 Wien, Österreich
          <br />
          E-Mail:{" "}
          <a href="mailto:hello@studioops.io" className="text-brand hover:underline">
            hello@studioops.io
          </a>
        </p>
      </Section>

      <Section title="2. Welche Daten wir erheben">
        <p>Wir verarbeiten folgende Kategorien personenbezogener Daten:</p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li>
            <strong>Stammdaten:</strong> Name, Geschäftsname, E-Mail-Adresse,
            Geschäftsadresse, UID-Nummer.
          </li>
          <li>
            <strong>Vertrags-/Zahlungsdaten:</strong> gewählter Tarif,
            Abrechnungsintervall, Zahlungsbelege (Abwicklung über Stripe).
          </li>
          <li>
            <strong>Nutzungsdaten:</strong> Login-Zeitpunkte, IP-Adresse zur
            Brute-Force-Erkennung (temporär), erstellte Rezepte/Cocktails,
            Mengenkalkulationen, AI-Credit-Nutzung.
          </li>
          <li>
            <strong>Inhaltsdaten:</strong> von Ihnen eingegebene Zutaten,
            Rezepturen, Speisekarten, Logo.
          </li>
        </ul>
      </Section>

      <Section title="3. Zweck der Verarbeitung">
        <ul className="list-disc pl-5 space-y-1.5">
          <li>Bereitstellung und Betrieb der SaaS-Plattform StudioOps Food</li>
          <li>Abwicklung von Abonnements und Rechnungslegung</li>
          <li>Erstellung von KI-generierten Rezepten und Cocktails</li>
          <li>Erfüllung steuerlicher und gesetzlicher Aufbewahrungspflichten</li>
          <li>Kundensupport und Sicherheit (Missbrauchserkennung)</li>
        </ul>
      </Section>

      <Section title="4. Rechtsgrundlage (Art. 6 DSGVO)">
        <ul className="list-disc pl-5 space-y-1.5">
          <li>
            <strong>Art. 6 Abs. 1 lit. b DSGVO</strong> — Erfüllung des
            Nutzungsvertrags (Bereitstellung der Plattform, Abrechnung).
          </li>
          <li>
            <strong>Art. 6 Abs. 1 lit. c DSGVO</strong> — Erfüllung rechtlicher
            Verpflichtungen (z. B. UStG, BAO, Aufbewahrungsfristen 7 Jahre).
          </li>
          <li>
            <strong>Art. 6 Abs. 1 lit. f DSGVO</strong> — berechtigtes Interesse
            an Sicherheit, Missbrauchsabwehr und Weiterentwicklung der
            Plattform.
          </li>
          <li>
            <strong>Art. 6 Abs. 1 lit. a DSGVO</strong> — Einwilligung (z. B.
            für optionale Marketing-E-Mails, jederzeit widerrufbar).
          </li>
        </ul>
      </Section>

      <Section title="5. Speicherung in der EU (Hosting)">
        <p>
          Unsere Plattform wird auf Servern innerhalb der Europäischen Union
          betrieben (<strong>Hostinger</strong>, Rechenzentren in der EU). Es
          findet <strong>keine</strong> Übermittlung Ihrer Daten in Drittländer
          außerhalb des EWR statt, soweit nicht im folgenden Abschnitt
          ausdrücklich genannt.
        </p>
      </Section>

      <Section title="6. Drittanbieter / Auftragsverarbeiter">
        <p>
          Folgende Auftragsverarbeiter unterstützen uns bei der Erbringung
          unserer Dienste. Mit allen wurden Auftragsverarbeitungsverträge
          (AVV) gemäß Art. 28 DSGVO abgeschlossen:
        </p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li>
            <strong>Stripe Payments Europe, Ltd.</strong> (Irland) — Abwicklung
            von Zahlungen, Abos, Rechnungen. Datenübermittlung in die USA nur
            auf Basis von Standardvertragsklauseln (SCC).
          </li>
          <li>
            <strong>Anthropic PBC</strong> (USA) — KI-Rezept- und
            Cocktail-Generierung über Claude. Eingaben werden ausschließlich zur
            Bearbeitung der jeweiligen Anfrage übertragen; kein Training auf
            Nutzerinhalten. Übermittlung auf Basis von SCC.
          </li>
          <li>
            <strong>Sendinblue SAS (Brevo)</strong> (Frankreich) — Versand
            transaktionaler E-Mails (Willkommen, Passwort-Reset,
            Rechnungen). Hosting innerhalb der EU.
          </li>
        </ul>
      </Section>

      <Section title="7. Speicherdauer">
        <p>
          Wir speichern personenbezogene Daten nur so lange, wie es für die
          oben genannten Zwecke erforderlich ist oder gesetzliche
          Aufbewahrungspflichten (z. B. 7 Jahre für Rechnungen gemäß § 132 BAO)
          dies vorschreiben. Nach Kündigung Ihres Accounts werden Stammdaten
          innerhalb von 30 Tagen gelöscht oder anonymisiert, sofern keine
          gesetzliche Aufbewahrungspflicht entgegensteht.
        </p>
      </Section>

      <Section title="8. Ihre Rechte (Art. 15 – 22 DSGVO)">
        <p>Ihnen stehen folgende Rechte zu:</p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li>
            <strong>Art. 15 DSGVO</strong> — Recht auf Auskunft über die zu
            Ihrer Person gespeicherten Daten.
          </li>
          <li>
            <strong>Art. 16 DSGVO</strong> — Recht auf Berichtigung unrichtiger
            Daten.
          </li>
          <li>
            <strong>Art. 17 DSGVO</strong> — Recht auf Löschung („Recht auf
            Vergessenwerden").
          </li>
          <li>
            <strong>Art. 18 DSGVO</strong> — Recht auf Einschränkung der
            Verarbeitung.
          </li>
          <li>
            <strong>Art. 20 DSGVO</strong> — Recht auf Datenübertragbarkeit
            (Datenexport).
          </li>
          <li>
            <strong>Art. 21 DSGVO</strong> — Widerspruchsrecht gegen
            Verarbeitungen auf Basis berechtigter Interessen.
          </li>
          <li>
            <strong>Art. 22 DSGVO</strong> — Recht, nicht ausschließlich
            automatisierten Entscheidungen unterworfen zu werden.
          </li>
        </ul>
        <p>
          Sie können diese Rechte jederzeit per E-Mail an{" "}
          <a href="mailto:hello@studioops.io" className="text-brand hover:underline">
            hello@studioops.io
          </a>{" "}
          geltend machen. Zur Identifikation kann eine Bestätigung über die
          beim Account hinterlegte E-Mail-Adresse erforderlich sein.
        </p>
      </Section>

      <Section title="9. Cookies">
        <p>
          Wir verwenden ausschließlich <strong>technisch notwendige Cookies</strong>{" "}
          (Session-Token, Spracheinstellung, Cookie-Banner-Status). Es findet
          kein Tracking, kein Marketing-Cookie-Einsatz und keine Übermittlung
          an Werbenetzwerke statt.
        </p>
      </Section>

      <Section title="10. Beschwerderecht bei der Aufsichtsbehörde">
        <p>
          Sie haben das Recht, sich bei der österreichischen Datenschutzbehörde
          zu beschweren:
          <br />
          Österreichische Datenschutzbehörde, Barichgasse 40-42, 1030 Wien,{" "}
          <a
            href="https://www.dsb.gv.at"
            target="_blank"
            rel="noopener noreferrer"
            className="text-brand hover:underline"
          >
            www.dsb.gv.at
          </a>
          .
        </p>
      </Section>
    </LegalLayout>
  );
}
